// extracted by mini-css-extract-plugin
module.exports = {"short-answer":"styles_short-answer__2lXvV","short-answer--disabled":"styles_short-answer--disabled__eCFZB"};